<template>
  <div class="timeline-entry d-flex">
    <div class="time mt-1">
      <span>{{ entry.dateTime | formatTimeOnly }}</span>
    </div>
    <div
      class="bullet"
      :class="getTimelineEntryClass(entry)"
      :style="{ '--event-color': entry.eventColor }"
    />
    <div class="d-flex flex-column mt-1">
      <div class="title mb-1 pre-wrap">
        <strong class="mr-1" style="white-space:normal;">{{
          entry.eventName
        }}</strong>
        <span class="mr-1">{{ preposition }}</span>
        <span class="mr-2">{{ entry.userName }}</span>
        <template v-if="entry.type == 'Document'">
          <template v-if="entry.status == 'Completed'">
            <a
              href="#"
              class="mr-2"
              @click.prevent="$emit('onViewDocument', entry.primaryEntityId)"
              v-if="
                hasCurrentUserDocumentPermission(entry.formId, 'isReadOnly')
              "
            >
              <strong>View</strong>
            </a>
          </template>
          <template v-else>
            <a
              href="#"
              class="mr-2"
              @click.prevent="$emit('onEditDocument', entry.primaryEntityId)"
              v-if="
                hasCurrentUserDocumentPermission(
                  entry.formId,
                  'hasCompleteAccess'
                )
              "
            >
              <strong>Edit</strong>
            </a>
            <a
              href="#"
              class="mr-2"
              @click.prevent="$emit('onDeleteDocument', entry.primaryEntityId)"
              v-if="
                hasCurrentUserDocumentPermission(
                  entry.formId,
                  'hasCompleteAccess'
                )
              "
            >
              <strong>Delete</strong>
            </a>
          </template>
        </template>
        <template
          v-else-if="entry.type == 'GroupSession' && entry.secondaryEntityId"
        >
          <a
            href="#"
            class="mr-2"
            @click.prevent="$emit('onViewGroupNote', entry.secondaryEntityId)"
          >
            <strong>View Note</strong>
          </a>
        </template>
        <template v-else-if="entry.type == 'ChartNote' && showChartNoteActions">
          <a
            href="#"
            class="mr-2"
            @click.prevent="$emit('onEditChartNote', entry.primaryEntityId)"
          >
            <strong>Edit</strong>
          </a>
          <a
            href="#"
            class="mr-2"
            @click.prevent="$emit('onDeleteChartNote', entry.primaryEntityId)"
          >
            <strong>Delete</strong>
          </a>
        </template>
      </div>
      <div
        v-if="entry.eventDetails"
        v-html-sanitize="entry.eventDetails"
        class="details"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "EocViewSummaryTimelineEntry",
  props: ["entry"],
  methods: {
    getTimelineEntryClass(entry) {
      if(entry.status){
        return entry.status.toLowerCase();
      }
      if (entry.type == "Appointment" || entry.type == "GroupSession") return "event-appointment-or-group-session";
      return '';
    }
  },  
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser
    }),
    ...mapGetters("layout", [
      "hasCurrentUserPermissionAccess",
      "hasCurrentUserDocumentPermission"
    ]),
    preposition() {
      if (
        this.entry.type == "Document" ||
        this.entry.type == "Vitals" ||
        this.entry.type == "ChartNote"
      )
        return "by";
      if (this.entry.type == "GroupSession" || this.entry.type == "Appointment")
        return "with";
      if (this.entry.type == "Medication") return "given by";

      throw new Error(`Unknown event type: ${this.entry.type}`);
    },
    showChartNoteActions() {
      return (
        this.currentUser.id == this.entry.userId ||
        this.hasCurrentUserPermissionAccess("patients", "editAllNotes")
      );
    }
  }
};
</script>

<style lang="scss">
.timeline-entry {
  background-image: linear-gradient(#d3d3d3, #d3d3d3);
  background-size: 5px 100%;
  background-position: 105px 0;
  background-repeat: no-repeat;
  gap: 18px;
  padding: 0.75rem 0.5rem;

  @mixin event-style($color) {
    background-color: $color;
  } 

  .time {
    font-weight: bold;
    font-size: 14px;
    min-width: 70px;
    text-align: end;
  }

  .bullet {
    position: relative;
    min-width: 24px;
    height: 24px;
    border-radius: 4px;
    background-color: #4044e6;

    &.completed {
      background-color: #01be0e;
    }
    &.pending {
      background-color: #ffc300;
    }
    &.draft {
      background-color: #ff6161;
    }
    &.event-appointment-or-group-session {
      @include event-style(var(--event-color));
    }

    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: white;
      border-radius: 50%;
    }
  }

  .title {
    font-size: 14px;
    line-height: 1.35;
    margin-top: -1px;
  }

  .details {
    font-size: 13px;

    ul {
      padding-left: 20px;
      margin-bottom: 0;
    }
    p {
      margin-bottom: 0;
    }
  }
}
</style>
